'use client';
import Image from 'next/image';
import Icon from '../Icon';

interface Props {
  navigate: (s: string) => void;
  obStep: number;
  setObStep: (n: number) => void;
  obVariant: 'A' | 'B';
  setObVariant: (v: 'A' | 'B') => void;
  onFinish: () => void;
}

const STEPS = ['기본 정보', '관심 분야', '알림 설정', '완료'];

function StepContent({ step, onFinish, navigate }: { step: number; onFinish: () => void; navigate: (s: string) => void }) {
  if (step === 1) return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div><h2 style={{ fontSize: 23, fontWeight: 700, margin: '0 0 4px' }}>기업 기본 정보</h2><p style={{ fontSize: 14, color: '#434654', margin: 0 }}>맞춤 매칭의 핵심이 되는 필수 정보입니다.</p></div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
        <label style={{ fontSize: 14, fontWeight: 600, color: '#434654' }}>기업 형태</label>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {[{ label: '법인', active: true }, { label: '개인사업자' }, { label: '예비창업자' }].map(o => (
            <span key={o.label} style={{ padding: '11px 18px', borderRadius: 10, background: o.active ? '#003d9b' : '#fff', color: o.active ? '#fff' : '#434654', fontSize: 14, fontWeight: 600, border: o.active ? 'none' : '1px solid #c3c6d6', cursor: 'pointer' }}>{o.label}</span>
          ))}
        </div>
      </div>
      <div className="vstack-sm" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
        {[{ label: '업종', opts: ['IT·소프트웨어', '제조', '바이오·의료', '그린·에너지'] }, { label: '소재지', opts: ['서울특별시', '경기도', '인천광역시', '그 외'] }].map(f => (
          <div key={f.label} style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
            <label style={{ fontSize: 14, fontWeight: 600, color: '#434654' }}>{f.label}</label>
            <select style={{ width: '100%', padding: '12px 14px', border: '1px solid #c3c6d6', borderRadius: 10, fontFamily: 'inherit', fontSize: 15, background: '#f7f8ff', color: '#051a3e', outline: 'none' }}>
              {f.opts.map(o => <option key={o}>{o}</option>)}
            </select>
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
        <label style={{ fontSize: 14, fontWeight: 600, color: '#434654' }}>창업 연월</label>
        <input defaultValue="2023.04" style={{ width: '100%', padding: '12px 14px', border: '1px solid #c3c6d6', borderRadius: 10, fontFamily: 'inherit', fontSize: 15, background: '#f7f8ff', color: '#051a3e', outline: 'none' }} />
      </div>
    </div>
  );

  if (step === 2) return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 22 }}>
      <div><h2 style={{ fontSize: 23, fontWeight: 700, margin: '0 0 4px' }}>관심 분야 &amp; 보유 인증</h2><p style={{ fontSize: 14, color: '#434654', margin: 0 }}>선택할수록 추천 정확도가 올라갑니다.</p></div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <label style={{ fontSize: 14, fontWeight: 600, color: '#434654' }}>관심 지원 분야 <span style={{ color: '#737685', fontWeight: 400 }}>(복수 선택)</span></label>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {[{ label: 'R&D', active: true }, { label: '사업화', active: true }, { label: '자금' }, { label: '인력' }, { label: '수출', active: true }].map(o => (
            <span key={o.label} style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '10px 16px', borderRadius: 999, background: o.active ? '#003d9b' : '#fff', color: o.active ? '#fff' : '#434654', fontSize: 14, fontWeight: 600, border: o.active ? 'none' : '1px solid #c3c6d6', cursor: 'pointer' }}>
              {o.active && <Icon name="check" size={16} color="#fff" />}{o.label}
            </span>
          ))}
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <label style={{ fontSize: 14, fontWeight: 600, color: '#434654' }}>보유 인증</label>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {[{ label: '벤처기업', active: true }, { label: '이노비즈' }, { label: '메인비즈' }, { label: '해당 없음' }].map(o => (
            <span key={o.label} style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '10px 16px', borderRadius: 999, background: o.active ? '#003d9b' : '#fff', color: o.active ? '#fff' : '#434654', fontSize: 14, fontWeight: 600, border: o.active ? 'none' : '1px solid #c3c6d6', cursor: 'pointer' }}>
              {o.active && <Icon name="check" size={16} color="#fff" />}{o.label}
            </span>
          ))}
        </div>
      </div>
      <div style={{ background: '#eef6ff', border: '1px solid #d8e2ff', borderRadius: 11, padding: 14, display: 'flex', gap: 9, alignItems: 'flex-start' }}>
        <Icon name="auto_awesome" size={20} color="#003d9b" fill={1} />
        <span style={{ fontSize: 13, color: '#434654', lineHeight: 1.5 }}>입력한 보유 기술을 분석해 <strong style={{ color: '#003d9b' }}>기술 적합도 기반 R&D·사업화 과제</strong>를 우선 추천합니다.</span>
      </div>
    </div>
  );

  if (step === 3) return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div><h2 style={{ fontSize: 23, fontWeight: 700, margin: '0 0 4px' }}>알림 설정</h2><p style={{ fontSize: 14, color: '#434654', margin: 0 }}>놓치면 안 되는 공고를 제때 알려드립니다.</p></div>
      {[{ label: '알림 받을 이메일', val: 'founder@jeongwon.tech' }, { label: '휴대폰 번호', val: '010-1234-5678', hint: '카카오톡 알림 수신에 사용됩니다.' }].map(f => (
        <div key={f.label} style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
          <label style={{ fontSize: 14, fontWeight: 600, color: '#434654' }}>{f.label}</label>
          <input defaultValue={f.val} style={{ width: '100%', padding: '12px 14px', border: '1px solid #c3c6d6', borderRadius: 10, fontFamily: 'inherit', fontSize: 15, background: '#f7f8ff', color: '#051a3e', outline: 'none' }} />
          {f.hint && <span style={{ fontSize: 12, color: '#737685' }}>{f.hint}</span>}
        </div>
      ))}
      {[{ label: '맞춤 신규 공고 알림', sub: '프로필과 일치하는 새 공고 등록 시', on: true }, { label: '마감 리마인더', sub: 'D-7 · D-3 · D-1 단계별 알림', on: true }, { label: '주간 요약 메일', sub: '매주 월요일 추천 공고 다이제스트', on: false }].map(t => (
        <div key={t.label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 14, background: '#f7f8ff', borderRadius: 11 }}>
          <div><div style={{ fontSize: 15, fontWeight: 600 }}>{t.label}</div><div style={{ fontSize: 13, color: '#737685' }}>{t.sub}</div></div>
          <span style={{ width: 46, height: 26, borderRadius: 999, background: t.on ? '#003d9b' : '#c3c6d6', position: 'relative', flexShrink: 0, display: 'inline-block' }}>
            <span style={{ position: 'absolute', top: 3, [t.on ? 'right' : 'left']: 3, width: 20, height: 20, borderRadius: '50%', background: '#fff', display: 'inline-block' }} />
          </span>
        </div>
      ))}
    </div>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 16, padding: '12px 0' }}>
      <span style={{ width: 84, height: 84, borderRadius: '50%', background: '#d6f0e2', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Icon name="check_circle" size={48} color="#1f8a5b" fill={1} />
      </span>
      <div><h2 style={{ fontSize: 26, fontWeight: 700, margin: '0 0 6px' }}>프로필 설정 완료!</h2><p style={{ fontSize: 16, color: '#434654', margin: 0 }}>정원테크님께 맞는 지원사업 <strong style={{ color: '#003d9b' }}>23건</strong>을 찾았어요.</p></div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
        {['R&D 8건', '사업화 9건', '수출 6건'].map(t => (
          <span key={t} style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 13, background: '#e9edff', color: '#003d9b', padding: '7px 14px', borderRadius: 999 }}>{t}</span>
        ))}
      </div>
      <button onClick={onFinish} style={{ marginTop: 8, width: '100%', background: '#003d9b', color: '#fff', border: 'none', cursor: 'pointer', padding: 15, borderRadius: 12, fontSize: 16, fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
        대시보드로 이동<Icon name="arrow_forward" size={19} color="#fff" />
      </button>
      <button onClick={() => navigate('list')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#434654', fontSize: 14, fontWeight: 600 }}>맞춤 공고 목록부터 보기</button>
    </div>
  );
}

export default function OnboardingScreen({ navigate, obStep, setObStep, obVariant, setObVariant, onFinish }: Props) {
  const isA = obVariant === 'A';

  function StepIndicator({ n }: { n: number }) {
    const done = n < obStep, active = n === obStep;
    const bg = done ? '#1f8a5b' : active ? '#003d9b' : '#e9edff';
    const color = done || active ? '#fff' : '#737685';
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 7, flex: 1 }}>
        <span style={{ width: 34, height: 34, borderRadius: '50%', background: bg, color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'JetBrains Mono',monospace", fontSize: 14, fontWeight: 600 }}>
          {done ? <Icon name="check" size={18} color="#fff" /> : n === 4 ? <Icon name="flag" size={18} color={color} /> : n}
        </span>
        <span style={{ fontSize: 12, color: '#434654' }}>{STEPS[n - 1]}</span>
      </div>
    );
  }

  const navBtns = (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 28, borderTop: '1px solid #eef1fb', paddingTop: 20 }}>
      {obStep > 1
        ? <button onClick={() => setObStep(obStep - 1)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#434654', fontSize: 15, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 4 }}><Icon name="arrow_back" size={19} />이전</button>
        : <span />}
      <button onClick={() => setObStep(Math.min(4, obStep + 1))} style={{ marginLeft: 'auto', background: '#003d9b', color: '#fff', border: 'none', cursor: 'pointer', padding: '13px 28px', borderRadius: 11, fontSize: 15, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6 }}>
        다음<Icon name="arrow_forward" size={19} color="#fff" />
      </button>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#f1f3ff', display: 'flex', flexDirection: 'column' }}>
      <style>{`@media(max-width:640px){.ob-split{flex-direction:column!important}.ob-split-left{width:100%!important;max-width:none!important;padding:32px 24px!important}}`}</style>
      {/* 상단 */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap', padding: '18px 28px', background: '#fff', borderBottom: '1px solid #e4e8f6' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
          <Image src="/vster-logo.png" alt="부스터" width={968} height={492} style={{ height: 28, width: 'auto' }} />
          <span style={{ fontSize: 18, fontWeight: 700, letterSpacing: '-.02em', color: '#051a3e', paddingLeft: 9, borderLeft: '1px solid #d8e2ff' }}>부스터</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <div style={{ display: 'flex', gap: 4, background: '#e9edff', padding: 4, borderRadius: 10 }}>
            {(['A', 'B'] as const).map(v => (
              <button key={v} onClick={() => setObVariant(v)} style={{ border: 'none', cursor: 'pointer', padding: '7px 14px', borderRadius: 7, fontSize: 13, fontWeight: 600, background: obVariant === v ? '#003d9b' : '#fff', color: obVariant === v ? '#fff' : '#434654' }}>
                {v === 'A' ? 'A · 스텝 카드' : 'B · 스플릿'}
              </button>
            ))}
          </div>
          <button onClick={() => navigate('home')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#737685', display: 'flex', alignItems: 'center', gap: 4, fontSize: 14 }}>
            <Icon name="close" size={20} />나가기
          </button>
        </div>
      </div>

      {/* A 변형 — 스텝 카드 */}
      {isA && (
        <div style={{ flex: 1, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '48px 20px', animation: 'vfade .35s ease' }}>
          <div style={{ width: '100%', maxWidth: 640, background: '#fff', border: '1px solid #e4e8f6', borderRadius: 20, padding: 36, boxShadow: '0 12px 40px rgba(5,26,62,.08)' }}>
            {/* 스텝 인디케이터 */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 32 }}>
              {[1, 2, 3, 4].map((n, i) => (
                <div key={n} style={{ display: 'flex', flex: 1, alignItems: 'center' }}>
                  <StepIndicator n={n} />
                  {i < 3 && <div style={{ height: 2, flex: .5, background: '#e4e8f6', marginBottom: 22 }} />}
                </div>
              ))}
            </div>
            <StepContent step={obStep} onFinish={onFinish} navigate={navigate} />
            {obStep < 4 && navBtns}
          </div>
        </div>
      )}

      {/* B 변형 — 스플릿 */}
      {!isA && (
        <div className="ob-split" style={{ flex: 1, display: 'flex', animation: 'vfade .35s ease' }}>
          {/* 왼쪽 패널 */}
          <div className="ob-split-left" style={{ width: '38%', maxWidth: 440, background: '#003d9b', color: '#fff', padding: '48px 40px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', position: 'relative', overflow: 'hidden' }}>
            <div style={{ position: 'absolute', inset: 0, opacity: .1, backgroundImage: 'linear-gradient(#fff 1px,transparent 1px),linear-gradient(90deg,#fff 1px,transparent 1px)', backgroundSize: '38px 38px' }} />
            <div style={{ position: 'relative', zIndex: 1 }}>
              <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 13, color: '#9fb6ff' }}>STEP {obStep} / 4 · {STEPS[obStep - 1]}</span>
              <h1 className="vh2" style={{ fontSize: 34, fontWeight: 700, lineHeight: 1.2, letterSpacing: '-.02em', margin: '18px 0 14px' }}>3분이면<br />맞춤 공고가<br />매일 도착해요</h1>
              <p style={{ fontSize: 16, lineHeight: 1.6, color: '#dae2ff', margin: 0 }}>기업 프로필을 알려주시면 자격이 맞는 지원사업만 골라 추천하고, 마감을 자동으로 챙겨드립니다.</p>
            </div>
            <div style={{ position: 'relative', zIndex: 1 }}>
              <div style={{ height: 8, borderRadius: 999, background: 'rgba(255,255,255,.2)', overflow: 'hidden', marginBottom: 10 }}>
                <div style={{ width: `${obStep / 4 * 100}%`, height: '100%', background: '#50dcff', transition: 'width .3s ease' }} />
              </div>
              <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 13, color: '#9fb6ff' }}>{STEPS[obStep - 1]} 단계 진행 중</span>
            </div>
          </div>
          {/* 오른쪽 패널 */}
          <div style={{ flex: 1, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '56px 32px', overflowY: 'auto' }}>
            <div style={{ width: '100%', maxWidth: 520 }}>
              <StepContent step={obStep} onFinish={onFinish} navigate={navigate} />
              {obStep < 4 && (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 30 }}>
                  {obStep > 1
                    ? <button onClick={() => setObStep(obStep - 1)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#434654', fontSize: 15, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 4 }}><Icon name="arrow_back" size={19} />이전</button>
                    : <span />}
                  <button onClick={() => setObStep(Math.min(4, obStep + 1))} style={{ marginLeft: 'auto', background: '#003d9b', color: '#fff', border: 'none', cursor: 'pointer', padding: '13px 30px', borderRadius: 11, fontSize: 15, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6 }}>
                    다음<Icon name="arrow_forward" size={19} color="#fff" />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
